import React, { Component } from "react";

function Answer(props) {
  let classes = ["button button-quiz-answer "];

  if (props.selected) {
    classes.push("active");
  }

  return (
    <>
      <div className="div-quiz-button">
        <button
          onClick={props.handleClick}
          className={classes.join(" ")}
          value={props.letter}
        >
          {props.answer}
        </button>
      </div>
    </>
  );
}

export default Answer;
